import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Ref } from '@eastsideco/salvo-ts';
import { cart } from '@/theme/Cart';
import { parseUrl, stringifyUrl } from 'query-string';
import axios from 'axios';

@Component
export class SideCart extends ThemeComponent {
    @Ref() updatingCart!: HTMLElement;
    @Ref() closeButton!: HTMLButtonElement[];
    @Ref() cartQuantity!: HTMLElement;

    init() {

        // Listen for outer side cart click
        this.listenForOuterSideCartClick();

        // Listen for cart item added
        this.listenForCartChanged();

        // Listen for close button click
        this.listenForCloseButtonClick();

        // Handle cart quantity update
        this.$subscribe(cart.onChange, () => this.cartQuantityUpdate());
    }

    public setLoading(loading: boolean = false) {
        if (loading) {
            this.updatingCart.classList.add('loading-spinner--active');
        } else {
            this.updatingCart.classList.remove('loading-spinner--active');
        }
    }

    private listenForOuterSideCartClick() {
        this.$listen(this, 'click', (e) => {
            if (e.target) {
                const clickedElement = e.target as HTMLElement;
                if (clickedElement.closest('.side-cart__inner')) {
                    return;
                }
                this.close();
            }
        });
    }

    private listenForCartChanged() {
        document.addEventListener('cartChanged', async(e: Event) => {

            // Set loading
            this.setLoading(true);

            // Build URL and get latest side cart markup
            const { url, query } = parseUrl(window.location.href, { decode: false });
            const newUrl = stringifyUrl({
                url: url,
                query: {
                    ...query,
                    sections: 'side-cart',
                }
            }, { arrayFormat: 'none', encode: false });
            const res = await axios.get(newUrl);

            // Prepare correct markup
            const newSideCart = document.createElement('div');
            newSideCart.innerHTML = res.data['side-cart'];
            const newSideCartMain = newSideCart.querySelector('.side-cart__main');
            const currentSideCartMain = this.querySelector('.side-cart__main');
            if (newSideCartMain && currentSideCartMain) {
                currentSideCartMain.outerHTML = newSideCartMain.outerHTML;
            }

            // Show side cart
            this.open();

            // Set loading
            this.setLoading(false);

            // We need to reassign the close button to the
            // newly rendered element. This could be avoided if
            // we move the header out of the side-cart__main, but we lose
            // flex properties that negate the need for explicit side
            // cart element heights
            this.closeButton = Array.from(this.querySelectorAll('[data-ref="closeButton"]')) || null;
            // Listen for close button click
            this.listenForCloseButtonClick();
        });
    }

    private listenForCloseButtonClick() {
        for (const button of this.closeButton) {
            this.$listen(button, 'click', (e) => {
                this.close();
            });
        }
    }

    private cartQuantityUpdate() {
        const count = cart.getCartItemCount();
        this.cartQuantity.textContent = `(${count.toString()})`;
    }

    public open() {
        this.classList.add('side-cart--active');

        // Disable body scrolling
        document.body.classList.add('prevent-scroll');
    }

    public close() {
        this.classList.remove('side-cart--active');

        // Enable body scrolling
        document.body.classList.remove('prevent-scroll');
    }
}
